import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {
  setScrollLeft,
  getRelativeOffset,
  getOffsetLeft,
  getElementWidth,
} from '../../../common/dom/domUtils';

export default class HbHorizontalScrollView extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    initialFocusedItemIndex: PropTypes.number,
    initialFocusedItemCenter: PropTypes.bool,
    rootElementType: PropTypes.string.isRequired,
    scrollDuration: PropTypes.number,
  }

  static defaultProps = {
    rootElementType: 'div',
    nativeScroll: setScrollLeft
  }

  componentDidMount() {
    this.setScrollLeft();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {initialFocusedItemIndex} = this.props;

    if (prevProps.initialFocusedItemIndex !== initialFocusedItemIndex) {
      this.setScrollLeft();
    }
  }

  setScrollLeft() {
    const {
      initialFocusedItemIndex,
      initialFocusedItemCenter,
      scrollDuration,
      nativeScroll,
    } = this.props;

    if (initialFocusedItemIndex < 0 || !process.env.BROWSER) {
      return;
    }

    const containerOffsetLeft = getOffsetLeft(this.containerNode);
    const containerWidth = getElementWidth(this.containerNode);

    const initialFocusedElement = this.containerNode.children[initialFocusedItemIndex];
    const initialFocusedElementOffset = getRelativeOffset(initialFocusedElement);
    const initialFocusedElementWidth = getElementWidth(initialFocusedElement);

    const scrollLeft = initialFocusedItemCenter
      ? (containerOffsetLeft + (initialFocusedElementOffset.left - (containerWidth / 2))) + (initialFocusedElementWidth / 2)
      : containerOffsetLeft + initialFocusedElementOffset.left;


    nativeScroll(this.containerNode, scrollLeft, scrollDuration);
  }

  ref = (node) => {
    this.containerNode = node;
  }

  render() {
    const {
      children,
      className,
      rootElementType: RootElementType,
    } = this.props;

    return (
      <RootElementType
        className={className}
        ref={this.ref}>
        {children}
      </RootElementType>
    );
  }
}

